import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";
import { Linking } from "@lib/utilities/Linking";
import { navigationRef } from "./NavigationServices";
import {
  BILLING_PAYMENTS_ROUTE,
  CONTACT_AGENT_ROUTE,
  LOGIN_ROUTE,
  MAKE_CLAIM_ROUTE,
  POLICY_ACTION_ROUTE,
  POLICY_LISTING_ROUTE,
  REGISTER_ROUTE,
  DOCUMENTS_INFO_ROUTE,
  RootStackParamList,
  DELETE_ACCOUNT_ROUTE,
  RESET_PASSWORD_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  PDF_VIEWER_ROUTE,
  AUTH_WEBVIEW_ROUTE,
  screenTitles,
  SHAREABLE_ROUTE,
  ACCOUNT_DELETION,
} from "./NavigationConstants";

import {
  LoginScreen,
  Register,
  PolicyActions,
  PolicyListing,
  ContactAgent,
  MakeClaim,
  DocumentsInfo,
  BillingPayments,
  DeleteAccount,
  ResetPassword,
  ForgotPassword,
  PDFViewer,
  AuthWebView,
  Shareable,
  AccountDeletion,
} from "../screens";
import { Platform } from "react-native";

const Stack = createNativeStackNavigator<RootStackParamList>();

const commonScreenOptions = {
  headerShown: false,
};

const RootStack = () => {
  return (
    <NavigationContainer linking={Linking} ref={navigationRef}>
      <Stack.Navigator screenOptions={commonScreenOptions}>
        <Stack.Screen
          name={LOGIN_ROUTE}
          component={LoginScreen}
          options={{ title: screenTitles.login }}
        />
        <Stack.Screen
          name={SHAREABLE_ROUTE}
          component={Shareable}
          options={{ title: screenTitles.shareable }}
        />
        <Stack.Screen
          name={REGISTER_ROUTE}
          component={Register}
          options={{ title: screenTitles.register }}
        />
        <Stack.Screen
          name={POLICY_LISTING_ROUTE}
          component={PolicyListing}
          options={{
            animation: "none",
            title: screenTitles.policyListing,
            fullScreenGestureEnabled: false,
            gestureEnabled: false,
          }}
        />
        <Stack.Screen
          name={POLICY_ACTION_ROUTE}
          component={PolicyActions}
          options={{ title: screenTitles.policyActions }}
        />
        <Stack.Screen
          name={CONTACT_AGENT_ROUTE}
          component={ContactAgent}
          options={{ title: screenTitles.contactAgent }}
        />
        <Stack.Screen
          name={MAKE_CLAIM_ROUTE}
          component={MakeClaim}
          options={{ title: screenTitles.makeClaim }}
        />
        <Stack.Screen
          name={BILLING_PAYMENTS_ROUTE}
          component={BillingPayments}
          options={{ title: screenTitles.billingPayments }}
        />
        <Stack.Screen
          name={DOCUMENTS_INFO_ROUTE}
          component={DocumentsInfo}
          options={{ title: screenTitles.documentsInfo }}
        />
        <Stack.Screen
          name={DELETE_ACCOUNT_ROUTE}
          component={DeleteAccount}
          options={{ title: screenTitles.deleteAccount }}
        />
        <Stack.Screen
          name={RESET_PASSWORD_ROUTE}
          component={ResetPassword}
          options={{ title: screenTitles.resetPassword }}
        />
        <Stack.Screen
          name={FORGOT_PASSWORD_ROUTE}
          component={ForgotPassword}
          options={{ title: screenTitles.forgotPassword }}
        />
        <Stack.Screen
          name={PDF_VIEWER_ROUTE}
          component={PDFViewer}
          options={{ title: screenTitles.pdfViewer }}
        />
        {Platform.OS=="web"&&
        <Stack.Screen
          name={ACCOUNT_DELETION}
          component={AccountDeletion}
          options={{ title: screenTitles.accountDeletion }}
        />}
        {Platform.OS == "android" && (
          <Stack.Screen
            name={AUTH_WEBVIEW_ROUTE}
            component={AuthWebView}
            options={{ title: screenTitles.authWebView }}
          />
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
};

export default RootStack;
